/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import React from 'react';
import { noop } from 'lodash';

import PurchaseMethodsModelV25 from 'commons-vehicle/PurchaseMethodsV25/models/PurchaseMethodsModelV25.js';
import PurchaseMethodsModel from 'commons-vehicle/PurchaseMethods/models/PurchaseMethodsModel.js';
import PaymentSummary from 'commons-vehicle/Vehicle/components/Overview/PaymentSummary/PaymentSummary.jsx';
import Quote from 'commons-vehicle/Quote/models/QuoteModel.js';
import 'commons-vehicle/Vehicle/components/Overview/Overview.scss';

const Overview = ({
    imageUrl,
    isUsed,
    isReserved,
    optionalButton,
    optionalBuyCta,
    optionalAppointmentCta,
    packageName,
    purchaseMethods,
    purchaseMethodsV25,
    quote,
    taxCodes,
    taxesDisclaimer,
    title,
    sectionTitle,
    subTitleElement,
    includedDealerIncentives,
    hasSDInitialClickSent,
    onSetSDInitialClickEvent,
}) => {
    return (
        <div className="vehicle-overview__wrapper">
            <p className="sr-title-2 is-centered vehicle-overview__title">{sectionTitle}</p>
            {subTitleElement}
            <PaymentSummary
                title={title}
                imageUrl={imageUrl}
                packageName={packageName}
                isReserved={isReserved}
                purchaseMethods={purchaseMethodsV25 || purchaseMethods}
                taxCodes={taxCodes}
                taxesDisclaimer={taxesDisclaimer}
                optionalButton={optionalButton}
                quote={quote}
                optionalBuyCta={optionalBuyCta}
                optionalAppointmentCta={optionalAppointmentCta}
                isUsed={isUsed}
                includedDealerIncentives={includedDealerIncentives}
                hasSDInitialClickSent={hasSDInitialClickSent}
                onSetSDInitialClickEvent={onSetSDInitialClickEvent}
            />
        </div>
    );
};

Overview.defaultProps = {
    imageUrl: 'null',
    isUsed: false,
    isReserved: false,
    optionalButton: false,
    optionalBuyCta: '',
    optionalAppointmentCta: '',
    packageName: '',
    quote: '',
    sectionTitle: 'Title of section in XMS',
    subTitleElement: null,
    includedDealerIncentives: false,
    hasSDInitialClickSent: false,
    onSetSDInitialClickEvent: noop,
    taxesDisclaimer: '',
    purchaseMethods: new PurchaseMethodsModel(),
    purchaseMethodsV25: null,
};

Overview.propTypes = {
    imageUrl: PropTypes.string,
    isUsed: PropTypes.bool,
    isReserved: PropTypes.bool,
    optionalButton: PropTypes.func,
    optionalBuyCta: PropTypes.string,
    optionalAppointmentCta: PropTypes.string,
    packageName: PropTypes.string,
    purchaseMethods: PropTypes.shape({
        cashPurchase: PropTypes.object.isRequired,
        financing: PropTypes.object.isRequired,
    }),
    purchaseMethodsV25: PropTypes.instanceOf(PurchaseMethodsModelV25),
    quote: PropTypes.instanceOf(Quote.QuoteModel),
    taxCodes: PropTypes.string.isRequired,
    taxesDisclaimer: PropTypes.string,
    title: PropTypes.string.isRequired,
    sectionTitle: PropTypes.string,
    subTitleElement: PropTypes.element,
    includedDealerIncentives: PropTypes.bool,
    hasSDInitialClickSent: PropTypes.bool,
    onSetSDInitialClickEvent: PropTypes.func,
};

Overview.displayName = 'Overview';

export default Overview;
